<script>
import ErrorAlert from "@/components/errorAlert";
import Layout from "../../layouts/main";
import axios from "axios";
import store from '@/state/store';
import ChangePasswordModal from '@/components/changePasswordModal';
import { toast, variants } from "@/helpers/toaster";
import ConfirmationModal from '@/components/confirmationModal';

/**
 * Form Layouts component
 */
export default {
  page: {
    title: 'Novi objekat',
  },
  components: {ErrorAlert, Layout, ChangePasswordModal, ConfirmationModal},
  async created() {
    if (!this.$route.params.id) {
      store.commit('errorBag/RECORD', { status:["Employee not found."]});
      return;
    }
    this.$store.commit('loader/START_LOADING');

      await axios.get(`/super-admin/employees/${this.$route.params.id}`)
      .then(response => {
        this.partner_id = response.data.partner_id ?? '';
        this.partner_name = response.data.partner_name ?? '';
        this.object_id = response.data.object_id ?? '';
        this.limit = response.data.limit ?? '';
        this.name = response.data.user.name ?? '';
        this.email = response.data.user.email ?? '';
        this.object_code = response.data.object_code ?? '';
        this.object_name = response.data.object_name ?? '';
        this.object_number = response.data.object_number ?? 0;
        this.object_address = response.data.object_address ?? '';
        this.object_address2 = response.data.object_address2 ?? '';
        this.contact = response.data.contact ?? '';
      }).catch((error) => {
        if (error.response && error.response.status === 404) {
          store.commit('errorBag/RECORD', { status:["Employee not found."]});
        }
      }).finally(() => this.$store.commit('loader/END_LOADING'));

      this.$store.commit('loader/START_LOADING');

      await axios.get('/super-admin/employees/distinct-partners').then((r) => {
        this.partners = r.data;
        this.partner = this.partners.find(p => this.partner_id == p.partner_id);
      }).finally(() => this.$store.commit('loader/END_LOADING'));
  },
  methods: {
    async submitForm() {
      const req = {
        partner_id: this.partner.partner_id,
        partner_name: this.partner.partner_name,
        object_id: this.object_id,
        name: this.name,
        email: this.email,
        object_code: this.object_code,
        object_name: this.object_name,
        object_number: this.object_number,
        object_address: this.object_address,
        object_address2: this.object_address2,
        contact: this.contact,
      };

      if (this.limit) req['limit'] = this.limit;

      this.$store.commit('loader/START_LOADING');

      try {
        await axios.put(`/super-admin/employees/${this.$route.params.id}`, req);
        toast('Uspešna izmena objekta.', variants.SUCCESS)
        this.cancel();
      } catch(e) {
        // eslint-disable-next-line no-empty
      } finally {    
        this.$store.commit('loader/END_LOADING');
      }
    },
    async deleteEmployee() {
      this.$store.commit('loader/START_LOADING');

      try {
        await axios.delete(`/super-admin/employees/${this.$route.params.id}`);
        toast('Uspešno brisanje objekta.', variants.SUCCESS)
        this.cancel();
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {    
        this.$store.commit('loader/END_LOADING');
      }
    },
    cancel() {
      this.$router.push(`/super-admin/employees`)
    }
  },
  data() {
    return {
      disabled: true,
      partner_id: '',
      partners: [],
      partner: null,
      partner_name: '',
      object_id: '',
      limit: '',
      name: '',
      email: '',
      object_code: '',
      object_name: '',
      object_number: '',
      object_address: '',
      object_address2: '',
      contact: '',
    };
  },
};
</script>

<template>
  <Layout>
    <div>
      <ErrorAlert></ErrorAlert>

      <b-form @submit.prevent="submitForm()">

        <div class="row">
          <div class="offset-3 col-md-6">
            <div class="form-group">
              <label>
                Partner
              </label>
              <select v-model="partner" :disabled="disabled" @click.stop class="form-control custom-select px-2">
                <option :value="null" disabled selected>Izaberi partnera...</option>
                <option v-for="p in partners" :key="p.partner_id" :value="p">
                  {{ p.partner_name ? p.partner_name : 'Partner: ' + p.partner_id }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label>
                Id objekta
              </label>
              <b-form-input v-model="object_id"  :disabled="disabled" placeholder="" 
                            id="employee-object-id-input" type="text"></b-form-input>
            </div>

            <div class="form-group">
              <label>
                Naziv objekta
              </label>
              <b-form-input v-model="object_name" :disabled="disabled" placeholder="" 
                            id="employee-object-name-input" type="text"></b-form-input>
            </div>

            <div class="form-group">
              <label>
                Šifra objekta
              </label>
              <b-form-input v-model="object_code" :disabled="disabled" placeholder="" 
                            id="employee-object-code-input" type="text"></b-form-input>
            </div>

            <div class="form-group">
              <label>
                Adresa objekta
              </label>
              <b-form-input v-model="object_address" :disabled="disabled" placeholder="" 
                            id="employee-object-address-input" type="text"></b-form-input>
            </div>

            <div class="form-group">
              <label>
                Adresa objekta 2
              </label>
              <b-form-input v-model="object_address2" :disabled="disabled" placeholder="" 
                            id="employee-object-address-2-input" type="text"></b-form-input>
            </div>

            <div class="form-group">
              <label>
                Broj objekta
              </label>
              <b-form-input v-model="object_number" :disabled="disabled" placeholder="" 
                            id="employee-object-number-input" type="number"></b-form-input>
            </div>

            <div class="form-group">
              <label>
                Kontakt
              </label>
              <b-form-input v-model="contact" :disabled="disabled" placeholder="" 
                            id="employee-contact-input" type="text"></b-form-input>
            </div>
            <div class="form-group">
              <label>
                Ime objekta
              </label>
              <b-form-input v-model="name" :disabled="disabled"  placeholder="" 
                            id="employee-name-input" type="text"></b-form-input>
            </div>
            <div class="form-group">
              <label>
                Email
              </label>
              <b-form-input v-model="email" :disabled="disabled"  placeholder="" 
                            id="employee-name-input" type="text"></b-form-input>
            </div>
            <div class="text-right mb-2">
              <confirmation-modal buttonClass="" variant="danger" :message="`Da li ste sigurni da želite da obrišete objekat: ${this.object_name}?`" title="Izbriši objekat" buttonText="Izbriši" @onSubmit="deleteEmployee" />
              <change-password-modal buttonClass="mr-2" :employeeId="this.$route.params.id"/>
              <b-button type="button" variant="secondary" @click="cancel()">Nazad</b-button>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </Layout>
</template>
<style scoped>

input[type='radio'] {
  display: none;
}

.button {
  display: inline-block;
  position: relative;
  width: 50px;
  height: 50px;
  margin: 10px;
  cursor: pointer;
}

.button span {
  position: absolute;
  width: 50px;
  height: 50px;
  padding: 0;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  border-radius: 100%;
  background: #eeeeee;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  transition: ease .3s;

  display: flex; /* or inline-flex */
  align-items: center;
  justify-content: center;

  color: white;
  font-size: 24px
}

.button span:hover {
  padding: 10px;
}

.orange .button span {
  background: #FF5722;
}

.pink .button span {
  background: #e067ea;
}

.yellow .button span {
  background: #faf15d;
}

.amber .button span {
  background: #FFC107;
}

.lime .button span {
  background: #8BC34A;
}

.teal .button span {
  background: #009688;
}

.blue .button span {
  background: #2196F3;
}

.indigo .button span {
  background: #3F51B5;
}

</style>
